import { Endpoint, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { endpointClient, EndpointPathParameters } from './EndpointClient';

const factory = createStudyEntityHookFactory<Endpoint, EndpointPathParameters>(StudyEntityType.Endpoint);

export const useEndpoints = factory.list(endpointClient.list);
export const useEndpoint = factory.get(endpointClient.get);
